var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSteam = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#steam_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#191919",
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.986 0A8.01 8.01 0 0 0 0 7.36l4.289 1.77a2.26 2.26 0 0 1 1.278-.395h.124L7.6 5.973v-.041a3.023 3.023 0 0 1 6.048 0c0 1.66-1.36 3.02-3.024 3.02h-.068l-2.722 1.946v.109a2.26 2.26 0 0 1-2.268 2.258c-1.1 0-2.02-.789-2.227-1.823L.275 10.177A8.01 8.01 0 0 0 7.986 16C12.412 16 16 12.422 16 8c-.014-4.422-3.601-8-8.014-8M5.017 12.136l-.99-.408c.18.367.482.667.88.83.866.354 1.87-.055 2.227-.912a1.66 1.66 0 0 0 0-1.306 1.7 1.7 0 0 0-.92-.925 1.66 1.66 0 0 0-1.252-.014l1.017.422c.633.272.935.993.674 1.633-.261.653-.99.952-1.636.68m7.615-6.204a2.02 2.02 0 0 0-2.007-2.014A2.005 2.005 0 0 0 8.62 5.932c0 1.102.907 2.014 2.006 2.014a2.005 2.005 0 0 0 2.007-2.014m-3.519 0a1.512 1.512 0 0 1 3.024 0 1.512 1.512 0 0 1-3.024 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "steam_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#fff",
  rx: 8
})))));
export default SvgSteam;